var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileNotFound = function SvgFileNotFound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32964 66.2937H171.845C173.336 66.2933 174.545 65.0841 174.545 63.5927V56.9243H1.6311V60.598C1.63271 63.7441 4.18356 66.2937 7.32964 66.2937Z",
    fill: "#BDBDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45459 56.9483L57.3203 39.4006H120.808L174.369 56.9483H1.45459Z",
    fill: "#E2E2F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.807 31.7499H57.3203V39.4007H120.807V31.7499Z",
    fill: "#BDBDE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.3203 31.7499C57.3171 14.2181 71.5268 0.00318614 89.0588 5.3552e-07C106.59 -0.00318506 120.805 14.2065 120.808 31.7383C120.808 31.7421 120.808 31.746 120.808 31.7499H57.3203Z",
    fill: "#E2E2F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1642 66.3201L17.0676 162.178H157.088L113.842 66.3201H63.1642Z",
    fill: "#FFE5B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0781 176C125.743 176 157.088 169.812 157.088 162.178C157.088 154.544 125.743 148.356 87.0781 148.356C48.4123 148.356 17.0676 154.544 17.0676 162.178C17.0676 169.812 48.4123 176 87.0781 176Z",
    fill: "#FFD590"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.116 101.482L59.5331 137.064C59.9353 139.715 62.4102 141.537 65.0611 141.135C65.0626 141.135 65.0641 141.135 65.0657 141.134L120.286 132.728C122.937 132.326 124.76 129.85 124.358 127.2C124.357 127.198 124.357 127.196 124.357 127.195L118.939 91.6133L54.116 101.482Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.595 89.3296C118.192 86.6784 115.717 84.8557 113.067 85.2579C113.065 85.2582 113.063 85.2584 113.061 85.2587L57.841 93.6654C55.1903 94.0684 53.3675 96.543 53.7697 99.1935C53.77 99.1953 53.7702 99.1971 53.7704 99.1988L54.3448 103.212L119.17 93.3424L118.595 89.3296Z",
    fill: "#8B8CC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6207 99.631C60.6385 99.631 61.4636 98.8064 61.4636 97.7883C61.4636 96.7701 60.6385 95.9456 59.6207 95.9456C58.6028 95.9456 57.7776 96.7701 57.7776 97.7883C57.7776 98.8064 58.6028 99.631 59.6207 99.631Z",
    fill: "#C3C3E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3287 98.7624C66.3465 98.7624 67.1716 97.9369 67.1716 96.9188C67.1716 95.9015 66.3465 95.076 65.3287 95.076C64.3108 95.076 63.4856 95.9015 63.4856 96.9188C63.4856 97.9369 64.3108 98.7624 65.3287 98.7624Z",
    fill: "#FFE5B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0367 97.893C72.0546 97.893 72.8797 97.0675 72.8797 96.0503C72.8797 95.0321 72.0546 94.2067 71.0367 94.2067C70.0188 94.2067 69.1936 95.0321 69.1936 96.0503C69.1936 97.0675 70.0188 97.893 71.0367 97.893Z",
    fill: "#F7B548"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1641 66.3201C63.1641 66.3201 68.7192 74.466 88.6019 74.466C108.485 74.466 113.842 66.3201 113.842 66.3201H63.1641Z",
    fill: "url(#paint0_linear_1164_124898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1164_124898",
    x1: 88.5033,
    y1: 66.409,
    x2: 88.5033,
    y2: 71.0678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58759,
    stopColor: "#F3AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B548"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file_not_found.4d621e4f.svg";